import React from 'react';
import StatusPill from '../StatusPill';
import { Card, Header, Meta, Side, TeamName } from './styles';

export interface IScheduleSlotCardProps {
  teamName: string;
  arena: string;
  time: string;
  judge?: string | null;
  modality?: string | null;
  category?: string | null;
  status: string;
  disqualified?: boolean;
  /** Ação da rodada (Avaliar, Ver resultado, Desclassificar…). */
  action?: React.ReactNode;
}

const join = (...parts: (string | null | undefined)[]) =>
  parts.filter(p => p && p !== '-').join(' · ');

/**
 * Uma rodada do cronograma em formato de card, para substituir a tabela de
 * 43.75rem no celular (sem rolagem lateral).
 */
const ScheduleSlotCard: React.FC<IScheduleSlotCardProps> = ({
  teamName,
  arena,
  time,
  judge,
  modality,
  category,
  status,
  disqualified = false,
  action,
}) => (
  <Card $live={status === 'ongoing' && !disqualified} $muted={disqualified}>
    <Header>
      <TeamName $struck={disqualified}>{teamName}</TeamName>
      <StatusPill scope="slot" status={status} disqualified={disqualified} />
    </Header>
    <Side>
      <div>
        <Meta>{join(arena, time, judge ? `Juiz: ${judge}` : null)}</Meta>
        <Meta>{join(modality, category)}</Meta>
      </div>
      {action}
    </Side>
  </Card>
);

export default ScheduleSlotCard;
